const version ='1.6.6'
export default version
console.log(version)
